import { styled } from '@mui/material/styles';
import { GridContainer } from 'components/shared/Grid/Grid.components';

export const GridContainerWithMargin = styled(GridContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
  alignItems: 'flex-end'
}));
